import { WasteEntryDto } from '@/services/dtos'
import { getNameWithRole } from '@utils/member.utils'
import { Chip, Tooltip } from '@mui/material'
import moment from 'moment'

export const ChipWastedStatus = ({ wasteEntry, withTooltip }: { wasteEntry?: WasteEntryDto; withTooltip?: boolean }) => {
  const chip = (
    <Chip
      label="Mise en déchet"
      size="small"
      variant="outlined"
      sx={{ color: '#6e6e6eff', borderColor: '#6e6e6eff' }}
    />
  )

  if (!withTooltip || !wasteEntry) {
    return chip
  }

  const title = [
    `Déchet N° ${wasteEntry.no}`,
    `Collecté par ${getNameWithRole(wasteEntry.collectedBy)}`,
    `Créé par ${getNameWithRole(wasteEntry.createdBy)} le ${moment(wasteEntry.createdAt).format('DD/MM/YYYY HH:mm')}`,
  ].join('\n')

  return (
    <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{title}</span>} arrow>
      {chip}
    </Tooltip>
  )
}
